window.domainList = {
    dyactive2: 'http://dyactive2.vip.xunlei.com',
    dyactive: 'http://dyactive.vip.xunlei.com',
    dyact: 'http://dyact.vip.xunlei.com',
    dynamic: 'http://dynamic.vip.xunlei.com',
    dypay: 'http://dypay.vip.xunlei.com',
    act: 'http://act.vip.xunlei.com',
    vip: 'http://vip.xunlei.com'
};



//////////////////
// WEBPACK FOOTER
// ./src/common/config.js
// module id = 10
// module chunks = 2